import { Link } from "react-router-dom";
import { CATEGORIES } from "@/data/categories";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";

export default function Categories() {
  return (
    <div data-testid="categories-page">
      <PageHeader
        eyebrow="PRIORITY EXPORT CATEGORIES"
        title="What we source from India."
        sub="Six high-priority verticals matched to UK and European buyer demand — across food, packaging, industry and luxury manufacturing."
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {CATEGORIES.map((c, i) => (
            <div
              key={c.slug}
              className="border border-white/5 bg-zinc-900/40 rounded-lg p-6 hover:border-white/15 hover:bg-zinc-900 transition-colors"
              data-testid={`cat-card-${c.slug}`}
            >
              <div className="flex items-center justify-between">
                <div className="font-mono text-[10px] tracking-[0.22em] text-zinc-500">CAT.{String(i + 1).padStart(2, "0")}</div>
                <div className="font-mono text-[10px] tracking-[0.22em] text-amber-400">{c.short.toUpperCase()}</div>
              </div>
              <div className="mt-4 font-display text-[18px] font-semibold leading-tight">{c.name}</div>
              <p className="mt-2 text-[13.5px] text-zinc-400 leading-relaxed">{c.summary}</p>
              <ul className="mt-4 space-y-1.5">
                {c.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2 text-[13px] text-zinc-300">
                    <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400 mt-[3px] shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/quote"
                className="mt-5 inline-flex items-center gap-1.5 text-[12.5px] font-medium text-amber-400 hover:text-amber-300"
                data-testid={`cat-cta-${c.slug}`}
              >
                Request sourcing for this category <ArrowUpRight className="h-3.5 w-3.5" />
              </Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export function PageHeader({ eyebrow, title, sub }) {
  return (
    <section className="relative overflow-hidden border-b border-white/5">
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
      <div className="absolute -top-20 right-10 h-72 w-72 rounded-full bg-blue-600/10 blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-14 sm:pt-20 sm:pb-16">
        <div className="font-mono text-[11px] tracking-[0.22em] text-amber-400">{eyebrow}</div>
        <h1 className="mt-3 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-4xl">{title}</h1>
        {sub ? <p className="mt-4 text-zinc-400 max-w-2xl text-base sm:text-lg leading-relaxed">{sub}</p> : null}
      </div>
    </section>
  );
}
